<script lang="ts" setup>

import {FormValidationError} from "@/shared/components/ui/form2/index.ts";

defineProps<{
  error?: FormValidationError
}>()
</script>

<template>
  <p v-if="error" role="alert" id="radix-v-10-form-item-message" class="text-sm font-medium text-red-700 dark:text-red-900">
    {{ error.label }}
  </p>
</template>
